import React from "react";
import styles from "./skeleton-loader.module.scss";

type Props = {};

const SkeletonLoader = (props: Props) => {
  return <div className={styles.skeletonLoader} />;
};

export default SkeletonLoader;
